import { Box, Typography } from '@material-ui/core';
import { StandardDialog, ConfirmationButton, } from '@roc/ui';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { usePayoffRequestStore } from '@roc/feature-loans';
import RichTextEditor from '../utils/richTextEditor';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';


interface IPayoffCorrectionProps {
  loanId: number;
  open: boolean;
  onClose: () => void;
  document: Document;
}

const useStyles = makeStyles(theme => ({

}));

export const PayoffCorrectionDialog = observer(({ loanId, open, onClose, document }: IPayoffCorrectionProps) => {
  const classes = useStyles();
  const { payoffRequestStore } = usePayoffRequestStore();
  const [texComment, setTexComment] = useState('')
  const taskId = document?.taskId;

  useEffect(() => {
    async function getPayoffCorrection() {
      await payoffRequestStore.getPayoffCorrectionComment(loanId);
      setTexComment(payoffRequestStore.payoffCorrectionComment);
    }
    if (open) {
      getPayoffCorrection();
    }
  }, [open])

  const notifyServicer = async () => {
    await payoffRequestStore.notifyServicerForCorrection(loanId, payoffRequestStore.selectedPayoffId, texComment);
    await payoffRequestStore.getPayoffById(loanId, payoffRequestStore.selectedPayoffId);
    setTexComment(payoffRequestStore.payoffCorrectionComment);
    onClose();
  }

  const dialogActions = (<>
    <Box mr={2}>

      <ConfirmationButton
        onClick={notifyServicer}
        color="primary"
        variant="contained"
        testId="confirm"
        confirmDialogProps={{
          title: 'Payoff Correction',
          body:
            'Are you sure you want to send this Payoff correction to servicer?',
        }}
      >
        NOTIFY SERVICER
      </ConfirmationButton>
    </Box>
  </>)

  const getContent = () => {
    return (
      <Box display="flex" flexDirection="column" height="100%" width="100%">
        <Typography style={{ marginBottom: '10px' }} variant={"subtitle1"} >Correction comments:</Typography>
        <RichTextEditor
          value={payoffRequestStore.payoffCorrectionComment}
          onChange={(value) => setTexComment(value)}
          reloadDependencies={[payoffRequestStore.payoffCorrectionComment]}
        />
      </Box>
    )
  }

  return (
    <>
      {
        taskId ? (

          <CustomTaskDialog
            open={open}
            title={"Payoff Correction"}
            handleClose={onClose}
            dialogContent={
              getContent()
            }
            dialogActions={dialogActions}
            taskId={taskId}
          />
        ) :
          (

            <StandardDialog
              open={open}
              title={"Payoff Correction"}
              maxWidth="sm"
              handleClose={onClose}
              dialogContent={
                getContent()
              }
              dialogActions={dialogActions}
            />

          )

      }
    </>


  );
});